import React from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout";
import "./blogTemplate.css";

export default function Template({ data }) {
  const { markdownRemark } = data
  const { frontmatter, html } = markdownRemark
  return (
    <Layout>
      <div className="content-container">
        <article className="blog-post">
          <header className="blog-post-header">
            <h1 className="blog-title">{frontmatter.title}</h1>
            <div className="blog-post-meta">
              <time>{frontmatter.date}</time>
            </div>
          </header>
          <div
            className="blog-post-content"
            dangerouslySetInnerHTML={{ __html: html }}
          />
          <footer className="blog-post-footer">
            <Link to="/blog/" className="back-to-blog">
              ← Back to Blog
            </Link>
          </footer>
        </article>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`